export default "__VITE_ASSET__26sCCJIB__"